/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Deutsch11Inputs */

const en__field_enum_tuda_deutsch11 = /** @type {(inputs: _Field_Enum_Tuda_Deutsch11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de__field_enum_tuda_deutsch11 = /** @type {(inputs: _Field_Enum_Tuda_Deutsch11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {_Field_Enum_Tuda_Deutsch11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_deutsch11 = /** @type {((inputs?: _Field_Enum_Tuda_Deutsch11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Deutsch11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_deutsch11(inputs)
	return de__field_enum_tuda_deutsch11(inputs)
});
export { _field_enum_tuda_deutsch11 as "_field_enum_TUDA_DEUTSCH" }